export default __webpack_public_path__ + "static/media/EM1740.34I-41207_-24576_0.ad6c7f4a.jpg";